var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "normal-page" },
        [
          _vm.search.length > 0
            ? _c("oaFromBox", {
                attrs: {
                  dropdownList: _vm.dropdownList,
                  isAddBtn: true,
                  isViewSearch: false,
                  search: _vm.search,
                  title: "考勤组列表",
                  total: _vm.total,
                },
                on: {
                  addDataFn: _vm.addFn,
                  confirmData: _vm.confirmData,
                  dropdownFn: function ($event) {
                    _vm.drawer = true
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-box mt10" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableData, height: _vm.tableHeight },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "考勤组名称",
                      "min-width": "180",
                      prop: "name",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "考勤组成员",
                      "min-width": "250",
                      prop: "members",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  row.members
                                    .map(function (obj) {
                                      return obj.name
                                    })
                                    .join("、")
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "考勤班次",
                      "min-width": "300",
                      prop: "shifts",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._l(scope.row.shifts, function (item, index) {
                              return scope.row.shifts.length <= 3
                                ? _c("span", { key: index }, [
                                    _vm._v(
                                      _vm._s(item.name) +
                                        "  " +
                                        _vm._s(
                                          item.times[0].first_day_after == 0
                                            ? "当日"
                                            : "次日"
                                        ) +
                                        _vm._s(item.times[0].work_hours) +
                                        " - " +
                                        _vm._s(
                                          item.times[0].second_day_after == 0
                                            ? "当日"
                                            : "次日"
                                        ) +
                                        _vm._s(item.times[0].off_hours) +
                                        "\n              "
                                    ),
                                    item.times.length > 1
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                item.times[1].first_day_after ==
                                                  0
                                                  ? "当日"
                                                  : "次日"
                                              ) +
                                              " " +
                                              _vm._s(item.times[1].work_hours) +
                                              " -\n                " +
                                              _vm._s(
                                                item.times[1]
                                                  .second_day_after == 0
                                                  ? "当日"
                                                  : "次日"
                                              ) +
                                              _vm._s(item.times[1].off_hours) +
                                              "\n              "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            scope.row.shifts.length > 3
                              ? _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "top-start",
                                      trigger: "hover",
                                      width: "400",
                                    },
                                  },
                                  [
                                    _vm._l(
                                      scope.row.shifts,
                                      function (item, index) {
                                        return _c("span", { key: index }, [
                                          _vm._v(
                                            _vm._s(item.name) +
                                              " " +
                                              _vm._s(item.times[0].work_hours) +
                                              " - " +
                                              _vm._s(item.times[0].off_hours) +
                                              "、"
                                          ),
                                        ])
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      _vm._l(
                                        scope.row.shifts,
                                        function (item, index) {
                                          return _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: index <= 2,
                                                  expression: "index <= 2",
                                                },
                                              ],
                                              key: index,
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(item.name) +
                                                  "  " +
                                                  _vm._s(
                                                    item.times[0].work_hours
                                                  ) +
                                                  " - " +
                                                  _vm._s(
                                                    item.times[0].off_hours
                                                  ) +
                                                  " "
                                              ),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    index < 2 ? "、" : "..."
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "创建时间",
                      prop: "created_at",
                      width: "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { fixed: "right", label: "操作", width: "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["hr:attendance:team:edit"],
                                    expression: "['hr:attendance:team:edit']",
                                  },
                                ],
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editFn(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["hr:attendance:team:delete"],
                                    expression: "['hr:attendance:team:delete']",
                                  },
                                ],
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteFn(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-fixed" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.where.page,
                      "page-size": _vm.where.limit,
                      "page-sizes": [15, 20, 30],
                      total: _vm.total,
                      layout: "total,sizes, prev, pager, next, jumper",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.pageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.drawer,
            size: "700px",
            title: "未设置考勤组人员",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "box" },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.listData, "tooltip-effect": "dark" },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "人员姓名", prop: "name" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "部门", prop: "position" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(
                            scope.row.frames,
                            function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "frame-name over-text",
                                },
                                [
                                  _c("span", { staticClass: "icon-h" }, [
                                    _vm._v(
                                      "\n                " + _vm._s(item.name)
                                    ),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              item.is_mastart === 1 &&
                                              scope.row.frames.length > 1,
                                            expression:
                                              "item.is_mastart === 1 && scope.row.frames.length > 1",
                                          },
                                        ],
                                        attrs: { title: "主部门" },
                                      },
                                      [_vm._v("(主)")]
                                    ),
                                  ]),
                                ]
                              )
                            }
                          )
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "职位", prop: "job.name" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }